import { render } from "./CreatePayment3.vue?vue&type=template&id=29565e4a"
import script from "./CreatePayment3.vue?vue&type=script&lang=js"
export * from "./CreatePayment3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__